var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isDefaultLogo)?_c('div',{staticClass:"appicon",style:({ backgroundImage: ("url(" + (_vm.getLogoCSS()) + ")") })}):_c('img',{staticClass:"imageLogo",attrs:{"src":_vm.getLogoImageURL(),"alt":""}})}
var staticRenderFns = []

export { render, staticRenderFns }